<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-8.66-5v-10l8.66-5l8.66,5v10L0.5,802.5z M-6.43,796.5H7.43l-6.93-12 M0.5,794.5c-1.1,0-2-0.9-2-2l0,0l0,0l0,0
	c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2l0,0l0,0l0,0C2.5,793.6,1.6,794.5,0.5,794.5L0.5,794.5z"/>
</svg>

</template>